// import { useOutletContext } from "react-router-dom";
// import { useEffect } from "react";
// import EmptySection from "../components/Layout/EmptySection";

// const Discount = () => {
//   const { setTitle, setDescription, setBackButton } = useOutletContext();

//   useEffect(() => {
//     setTitle("Discounts");
//     setDescription(null);
//     setBackButton(false);
//   }, [setTitle, setDescription, setBackButton]);

//   return (
//     <>
//       <EmptySection entireText="Coming Soon!" />
//     </>
//   );
// };

// export default Discount;

import React, { useEffect, useState, useCallback } from "react";
import { Button, Space, Dropdown, Typography } from "antd";
import { TbDotsVertical } from "react-icons/tb";
import { PiCopyFill } from "react-icons/pi";
import { RiDeleteBin6Line } from "react-icons/ri";

import DataTable from "../components/Tables/Datatable";
import SearchInput from "../components/Forms/SearchInput";
import PrimaryButton from "../components/Forms/PrimaryButton";
import CustomBadge from "../components/Charts/CustomBadge";
import Loader from "../common/Loader";

import { useApiCall } from "../services/api";
import { useGlobalModal } from "../context/SuccessModalProvider";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useOutletContext, useSearchParams } from "react-router-dom";
import { formatDate, handleRouteNav } from "../utils";
import { MdOutlineEdit } from "react-icons/md";
import { FaBriefcase, FaRegUser } from "react-icons/fa";
import Block from "../components/models/Block";
import AssignClints from "../components/models/AssignClints";
import { items, roleIds } from "../constant";
import OfferStatusModal from "../components/models/OfferStatusModal";
import AddSchemeModal from "../components/models/AddSchemeModal";
import Filters from "../components/Filters";
import { listRefresh } from "../redux/auth/cartRefreshSlice";
import usePagination from "../hooks/usePagination";

const statusVariantMap = {
  Active: "success",
  Inactive: "pending",
  Expired: "danger",
};

const Discount = () => {
  const { postApi, loading } = useApiCall();
  const { is_sales_person, user_id, role_id, full_name } = useSelector((state) => state.auth);
  const location = useLocation();
  const [offerList, setOfferList] = useState([]);
  const { pagination, setPagination, handleChange: handlePaginationChange, resetPage } = usePagination();
  const { listRefreshKey } = useSelector((state) => state.cartRefresh);

  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") || "";

  const navigate = useNavigate();
  const { setTitle, setBackButton, setDescription } = useOutletContext();
  const handleChange = (paginationInfo) => {
    handlePaginationChange(paginationInfo);
  };

  const [isDeleteModal, setIsDeleteModel] = useState(false);
  const [offerId, setOfferId] = useState(null);
  const [assignClientModal, setAssignClientModal] = useState(false);
  const [selectedClientData, setSelectedClientData] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [userType, setUserType] = useState("");
  const [clients, setClients] = useState([]);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [status, setStatus] = useState("");
  const [isSchemeModalVisible, setSchemeModalVisible] = useState(false);
  const [schemeData, setSchemeData] = useState();
  const [isCopy, setIsCopy] = useState(false);
  const dispatch = useDispatch();

  const { appliedFilters, ModalUI, FilterButton } = Filters({
    filters: [
      {
        type: "select",
        key: "status",
        label: "Status",
        options: [
          { label: "Active", value: "Active" },
          { label: "Inactive", value: "Inactive" },
          { label: "Expired", value: "Expired" },
        ],

        inputProps: {
          placeholder: "Select Status",
        },
      },
      {
        type: "daterange",
        key: "schemeDate",
        label: "Active Dates",
      },
    ],
    onChange: () => resetPage(),
  });

  const columnsForSales = [
    {
      title: "ID",
      dataIndex: "offer_id",
      width: 80,
    },
    {
      title: "Scheme",
      dataIndex: "title",
      ellipsis: true,
      width: 300,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => <CustomBadge variant={statusVariantMap[status]} text={status} />,
      ellipsis: true,
      width: 150,
    },
    {
      title: "Assigned Clients",
      ellipsis: true,

      render: (_, record) => {
        const customers = record?.customers || [];

        if (!customers.length) return "-";
        const userData = customers.map((c) => c.company_name).join(", ");

        return userData;
      },
    },
  ];

  const columns = [
    {
      title: "ID",
      dataIndex: "offer_id",
      width: 80,
    },
    {
      title: "Scheme",
      dataIndex: "title",
      ellipsis: true,
      width: 300,
    },
    {
      title: "Status",
      dataIndex: "status",
      ellipsis: true,
      render: (status) => <CustomBadge variant={statusVariantMap[status]} text={status} />,
      width: 150,
    },
    {
      title: "Assigned Clients",
      ellipsis: true,

      render: (_, record) => {
        const customers = record?.customers || [];

        if (!customers.length) return "-";
        const userData = customers.map((c) => c.company_name).join(", ");

        return userData;
      },
    },
    {
      title: "Assigned Sales",
      dataIndex: "assigned_sales",
      render: (_, record) => {
        const users = record?.users || [];
        if (!users.length) return "-";
        const userData = users.map((c) => c.full_name).join(", ");
        return userData;
      },
      ellipsis: true,
    },
    {
      title: "",
      key: "action",
      fixed: "right",
      width: 60,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: (
                  <Space className="text-[#A33434] font-semibold">
                    <div className="bg-[#A33434] p-1.5 rounded-full text-white">
                      <MdOutlineEdit />
                    </div>
                    Edit Scheme
                  </Space>
                ),
                onClick: () => {
                  setSchemeData(record);
                  setSchemeModalVisible(true);
                },
                visible: role_id !== roleIds?.SalesPerson,
              },
              {
                label: (
                  <Space className="text-[#A33434] font-semibold">
                    <div className="bg-[#A33434] p-1.5 rounded-full text-white">
                      <PiCopyFill />
                    </div>
                    Copy Scheme
                  </Space>
                ),
                onClick: () => {
                  setSchemeData({
                    ...record,
                    title: `${record.title} copy`,
                    from_date: undefined,
                    to_date: undefined,
                  });
                  setSchemeModalVisible(true);
                  setIsCopy(true);
                },
                visible: role_id !== roleIds?.SalesPerson,
              },
              {
                label: (
                  <Space className="text-[#A33434] font-semibold">
                    <div className="bg-[#A33434] p-1.5 rounded-full text-white">
                      <FaBriefcase />
                    </div>
                    Assign Salespersons
                  </Space>
                ),
                onClick: (value) => {
                  setAssignClientModal(true);
                  getSelectedClientData(record?.users || [], "salesperson");
                  setUserType("salesperson");
                  setOfferId(record.offer_id);
                },
                visible: role_id !== roleIds?.SalesPerson,
              },
              {
                label: (
                  <Space className="text-[#A33434] font-semibold">
                    <div className="bg-[#A33434] p-1.5 rounded-full text-white">
                      <FaRegUser />
                    </div>
                    Assign Clients
                  </Space>
                ),
                onClick: (value) => {
                  setAssignClientModal(true);
                  getSelectedClientData(record?.customers || [], "customer");
                  setUserType("customer");
                  setOfferId(record.offer_id);
                },
                // visible: role_id === roleIds?.SalesPerson,
              },
              // {
              //   label: (
              //     <Space className="text-[#A33434] font-semibold">
              //       <div className="bg-[#A33434] p-1.5 rounded-full text-white">
              //         <img
              //           src="/assets/icons/ClockClockwise.png"
              //           alt="Cube"
              //           className="w-[15px] h-[15px] object-contain"
              //         />
              //       </div>
              //       Update Status
              //     </Space>
              //   ),
              //   onClick: (value) => {
              //     setOpenStatusModal(true)
              //     setOfferId(record.offer_id);
              //     setStatus(record?.status)
              //   },
              //   visible: role_id!== roleIds?.SalesPerson,
              // },
              {
                label: (
                  <Space className="text-[#A33434] font-semibold">
                    <div className="bg-[#A33434] p-1.5 rounded-full text-white">
                      <RiDeleteBin6Line />
                    </div>
                    Delete Scheme
                  </Space>
                ),
                onClick: (value) => {
                  setIsDeleteModel(true);
                  setOfferId(record);
                },
                visible: role_id !== roleIds?.SalesPerson,
              },
            ].filter((item) => item.visible !== false),
            onClick: ({ key, domEvent }) => {
              domEvent.stopPropagation();
            },
          }}
          trigger={["click"]}
          overlayClassName="custom-dropdown-sales-menu"
        >
          <Typography.Link
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Space>
              <TbDotsVertical className="text-red-700" size={18} />
            </Space>
          </Typography.Link>
        </Dropdown>
      ),
    },
  ];

  const getSelectedClientData = (data, type) => {
    const ids = data.map((item) =>
      type === "customer" ? Number(item.customer_id) : Number(item.user_id),
    );

    setSelectedClientData(ids);
  };

  const getSelectedClients = async (data) => {
    const payloadForClient = {
      offer_id: offerId,
      customer_ids: data,
    };

    const payloadForSalesperson = {
      offer_id: offerId,
      user_ids: data,
    };

    const payloadForClientRequest = {
      offer_id: offerId,
      offer_request_customer_ids: data,
      updated_by: full_name,
      updated_by_id: user_id,
    };

    const res = await postApi(
      `${userType === "customer" && role_id == roleIds?.SalesPerson ? "sales/offer/offer-request" : userType === "customer" ? "sales/offer/assign-clients" : "sales/offer/assign-sales"}`,
      userType === "customer" && role_id == roleIds?.SalesPerson
        ? payloadForClientRequest
        : userType === "customer"
          ? payloadForClient
          : payloadForSalesperson,
      true,
    );
    if (res && res.status) {
      setAssignClientModal(false);
      fetchOfferList();
    }
  };

  useEffect(() => {
    setTitle("Scheme List");
    setDescription(`${pagination.total} total schemes`);
    setBackButton(false);
  }, [setTitle, setBackButton, pagination.total]);

  const handleSearchInput = (e) => {
    const value = e.target.value;
    setSearchParams(
      (prev) => {
        if (value) prev.set("q", value);
        else prev.delete("q");
        return prev;
      },
      { replace: true },
    );
    resetPage();
  };

  const viewScheme = (record) => {
    navigate(handleRouteNav(`/scheme-details`, role_id), {
      state: { mode: true, offerId: record?.offer_id },
    });
  };

  const handleCancel = () => {
    setIsDeleteModel(false);
  };

  const handleDeleteOk = async () => {
    const res = await postApi("sales/offer/delete", { offer_id: offerId.offer_id }, true);
    if (res && res.status) {
      setIsDeleteModel(false);
      fetchOfferList();
    }
  };

  const fetchOfferList = async () => {
    const { status, schemeDate } = appliedFilters;

    const filters = {
      status,
      start_date: schemeDate?.[0]
        ? formatDate(new Date(schemeDate[0]), { format: "YYYY-MM-DD" })
        : undefined,
      end_date: schemeDate?.[1]
        ? formatDate(new Date(schemeDate[1]), { format: "YYYY-MM-DD" })
        : undefined,
    };

    const payload = {
      page: pagination.current,
      per_page: pagination.pageSize,
      search: query,
      user_id: is_sales_person ? user_id : undefined,
      ...(Object.keys(appliedFilters).length ? filters : {}),
    };
    const res = await postApi("sales/offer/list", payload);
    if (!res?.status) {
      setOfferList([]);
      setPagination({ total: 0 });
      return;
    }
    if (res && res.data) {
      setOfferList(res.data);
      setPagination({ total: res.total });
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchOfferList();
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [pagination.current, pagination.pageSize, query, location.state?.refresh, appliedFilters, listRefreshKey]);

  const fetchUsers = async () => {
    try {
      const body = {
        page: 1,
        per_page: 10000,
        search: searchUser,
      };
      const res = await postApi("user/list", body);
      if (!res?.status) {
        setAllUsers([]);
        return;
      }
      if (res && res.data) {
        const userList = res.data.filter((item) => item.role_id === roleIds?.SalesPerson);
        setAllUsers(userList);
      }
    } catch (err) {
    } finally {
    }
  };

  const fetchClients = async () => {
    try {
      const body = {
        page: 0,
        per_page: 0,
        search: searchUser,
        user_id: is_sales_person ? user_id : undefined,
      };
      const res = await postApi("sales/assign-customer-list", body);
      if (!res?.status) {
        setClients([]);
        return;
      }
      if (res && res.data) {
        setClients(res.data);
      }
    } catch (err) {
    } finally {
    }
  };

  const onSearch = (value) => {
    setSearchUser(value);
  };

  useEffect(() => {
    if (userType === "customer") {
      fetchClients();
    } else if (userType === "salesperson") {
      fetchUsers();
    }
  }, [searchUser, userType]);

  const updateStatus = async (value) => {
    try {
      const body = {
        offer_id: offerId,
        status: value.status,
      };
      const res = await postApi("sales/offer/status-update", body, true);
      setOpenStatusModal(false);
      fetchOfferList();
    } catch (err) {
    } finally {
    }
  };

  return (
    <>
      <ModalUI />
      <div className="bg-white rounded-[32px] overflow-hidden">
        <div className="flex justify-between items-center gap-3 px-8 py-6">
          <SearchInput
            placeholder="Search for schemes"
            value={query}
            onChange={handleSearchInput}
          />

          <div className="flex items-center gap-3">
            <FilterButton />
            <PrimaryButton
              text="Scheme Requests"
              onClick={() => navigate(handleRouteNav(`/scheme-requests`, role_id))}
              noIcon
            />
            <Button
              type="primary"
              className="h-[45px] bg-[#7070701A]  hover:!bg-[#7070701A] hover:!text-[#A33434] font-bold text-[#A33434] text-base !cursor-default"
            >
              {pagination.total} schemes
            </Button>
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <Loader size={60} />
          </div>
        ) : (
          <DataTable
            handleRow={viewScheme}
            columns={is_sales_person ? columnsForSales : columns}
            data={offerList}
            handleChange={handleChange}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              showSizeChanger: true,
              total: pagination.total,
            }}
          />
        )}
      </div>
      <Block
        open={isDeleteModal}
        onCancel={handleCancel}
        onConfirm={handleDeleteOk}
        title={
          <span>
            Do you want to delete <b>{offerId?.title}</b> from <b>Discount Schemes</b>?
          </span>
        }
        confirmText={"Delete Scheme"}
        btnText={"Delete"}
        loading={loading}
      />
      <AssignClints
        title={`${userType === "customer" ? "Assign Clients" : "Assign Salespersons"}`}
        open={assignClientModal}
        handleSubmit={getSelectedClients}
        onClose={() => setAssignClientModal(false)}
        selectedUserData={selectedClientData}
        userData={userType === "customer" ? clients : allUsers}
        onSearch={onSearch}
        userType={userType}
        loading={loading}
      />
      <OfferStatusModal
        status={status}
        handleFinish={updateStatus}
        isOpen={openStatusModal}
        closeModal={() => setOpenStatusModal(false)}
      ></OfferStatusModal>
      <AddSchemeModal
        isOpen={isSchemeModalVisible}
        closeModal={() => {
          setSchemeModalVisible(false);
          setIsCopy(false);
        }}
        schemeData={schemeData}
        isEdit={true}
        title={isCopy ? "Add Scheme" : "Edit Scheme"}
        btnText={isCopy ? "Add Scheme" : "Update Scheme"}
        editFromDiscoutns={true}
        copyScheme={isCopy}
        handleSubmit={() => dispatch(listRefresh())}
      ></AddSchemeModal>
    </>
  );
};

export default Discount;
